import React, { ReactElement } from 'react'
import Select from 'react-select'
import useCurves from '../hooks/useCurves'
import styled from 'styled-components'

type Props = { value: string; onChange: (value: string) => void; label: string }
ChannelSelector.DefaultProps = { label: 'Channel' }

const FieldWrapper = styled.div`
    .live-dropdown__content & .Select-input {
        color: #fff;
    }
`

export default function ChannelSelector(props: Props): ReactElement {
    const curves: AssetCurves[] = useCurves()

    return (
        <FieldWrapper>
            <label>{props.label}</label>
            <Select
                className={'dropdown-toggler--cancel-drag input-field'}
                options={curves}
                onChange={(curve: AssetCurves) => props.onChange(curve.mnemonic)}
                value={curves.find(c => c.mnemonic === props.value)}
            />
        </FieldWrapper>
    )
}
